import { EventInput } from '@fullcalendar/core';
import { Goal } from 'shared/types/goal';

export const getGoalsDeadlineEvents = (goals: Goal[]) =>
  goals.reduce<EventInput[]>((acc, goal) => {
    if (!goal.deadline) {
      return acc;
    }

    acc.push({
      id: goal.id,
      date: goal.deadline,
      allDay: true,
      title: goal.name,
      extendedProps: {
        goalId: goal.id,
        isDeadline: true,
      },
    });

    return acc;
  }, []);
